import { h, Component } from 'preact';

const modules = {};
const requests = {};

const toCamelCase = str => str.replace(/[-_\s]+(.)?/g, (match, chr) => (chr ? chr.toUpperCase() : ''));

// Accepts camelCase or slugs ('arrowDown', 'arrow-down'), plus '.Export' for files with multiple named exports
const parseName = name => {
	const [file, exportName] = String(name || '').trim().split('.');
	return { file: toCamelCase(file), exportName };
};

const pick = (mod, exportName) => {
	if (!mod) return null;
	if (exportName) return mod[exportName] || null;
	return mod.default || null;
};

const request = file => {
	if (!requests[file]) {
		requests[file] = import(/* webpackChunkName: "icon-[request]" */ `components/bolt/icons/${file}`)
			.catch(() => null)
			.then(mod => (modules[file] = mod));
	}

	return requests[file];
};

/**
 * Returns the icon component for a name, or null if it doesn't exist.
 */
export const getIcon = async name => {
	const { file, exportName } = parseName(name);

	if (!file) return null;

	const module = await request(file);
	return pick(module, exportName);
};

// Undefined until the file has been imported, so callers can tell "not loaded" from "no such icon"
export const cachedIcon = name => {
	const { file, exportName } = parseName(name);

	if (!file || !(file in modules)) return undefined;

	return pick(modules[file], exportName);
};

export default class Icon extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Comp: cachedIcon(props.name) || null
		};

		this.load = this.load.bind(this);
	}

	componentDidMount() {
		if (!this.state.Comp) {
			this.load(this.props.name);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.name !== this.props.name) {
			this.load(nextProps.name);
		}
	}

	async load(name) {
		const Comp = await getIcon(name);
		this.setState({ Comp });
	}

	render(props, state) {
		const { name, fallback, ...rest } = props;
		const { Comp } = state;

		if (!Comp) return fallback || null;
		return <Comp {...rest} />;
	}
}
